// frontend/src/components/NavBar.js
import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { User, LogOut } from 'lucide-react';

const NavBar = () => {
  const location = useLocation();
  const { user, signOut } = useAuth();
  
  const isActive = (path) => {
    return location.pathname === path;
  };

  const handleSignOut = async () => {
    await signOut();
  };

  return (
    <nav className="relative z-50 bg-gray-950/80 backdrop-blur-md border-b border-violet-900/50">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex justify-between items-center">
          <RouterLink to="/" className="flex items-center space-x-2">
            <span className="text-3xl">🗄️</span>
            <h1 className="text-2xl font-bold bg-gradient-to-r from-violet-400 to-purple-400 bg-clip-text text-transparent">
              DB2XL
            </h1>
          </RouterLink>
          
          <div className="flex items-center space-x-6">
            <RouterLink 
              to="/dashboard"
              className={`transition-colors ${
                isActive('/dashboard') 
                  ? 'text-violet-400' 
                  : 'text-gray-300 hover:text-white'
              }`}
            >
              Dashboard
            </RouterLink>
            <RouterLink 
              to="/connect"
              className={`transition-colors ${
                isActive('/connect') 
                  ? 'text-violet-400' 
                  : 'text-gray-300 hover:text-white'
              }`}
            >
              Connect DB
            </RouterLink>
            {/* Hide Upload SQL link temporarily
            <RouterLink 
              to="/upload"
              className={`transition-colors ${
                isActive('/upload') 
                  ? 'text-violet-400' 
                  : 'text-gray-300 hover:text-white'
              }`}
            >
              Upload SQL
            </RouterLink>
            */}
            
            {user && (
              <div className="flex items-center space-x-4 ml-6 pl-6 border-l border-gray-700">
                <RouterLink 
                  to="/profile"
                  className={`flex items-center space-x-2 transition-colors ${
                    isActive('/profile') 
                      ? 'text-violet-400' 
                      : 'text-gray-300 hover:text-white'
                  }`}
                >
                  <User className="w-4 h-4" />
                  <span>Profile</span>
                </RouterLink>
                <button
                  onClick={handleSignOut}
                  className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors"
                >
                  <LogOut className="w-4 h-4" />
                  <span>Sign Out</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;